import i from "./IstTooltip.vue2.mjs";
import { resolveComponent as p, openBlock as l, createBlock as c, withCtx as m, createTextVNode as f, toDisplayString as v } from "vue";
import _ from "../../_virtual/_plugin-vue_export-helper.mjs";
function a(s, o, e, u, t, d) {
  const n = p("popover");
  return l(), c(n, {
    name: "tooltip",
    pointer: e.pointer,
    width: e.width,
    event: e.event,
    onShow: o[0] || (o[0] = (r) => t.value = r.value)
  }, {
    default: m(() => [
      f(v(t.value), 1)
    ]),
    _: 1
  }, 8, ["pointer", "width", "event"]);
}
const k = /* @__PURE__ */ _(i, [["render", a]]);
export {
  k as default
};
